<template>
    <BasePanel 
    headline="lang_LABEL_TRACKS"
    :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="tracks"
                hide-default-footer
                :items-per-page="600"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
                <!-- alvqas for headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <!-- rows + alvqas -->
                <template v-slot:[`item.soundCarrierNumber`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-sound-carrier-number'">
                        {{ item.soundCarrierNumber }}
                    </div>
                </template>
                <template v-slot:[`item.trackPosition`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-track-position'">
                        {{ item.trackPosition }}
                    </div>
                </template>
                <template v-slot:[`item.title`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-title'">
                        {{ item.title }}
                    </div>
                </template>
                <template v-slot:[`item.isrc`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-isrc'">
                        {{ item.isrc }}
                    </div>
                </template>
                <template v-slot:[`item.performer`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip 
                            :simpleText="$alvPlugin.getArtistOrPerformerName(item.displayArtist)"
                            :alvqa="alvqa +'-list-row-' + item.id + '-text-performer'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.duration`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-duration'">
                        {{ $alvPlugin.transformSecondsToDuration(item.duration) }}
                    </div>
                </template>
                <template v-slot:[`item.jumpToBtn`]="{ item }">
                    <BaseButton 
                                label="lang_ERP_SHIPPING_CAPTION_LINKED_DOC_ABBREVIATION"
                                :alvqa="alvqa"
                                 @click.stop="jumpToTrack(item.alvId)"
                            />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "TracksReadOnlyPanel",
    components: {
        BasePanel,
        BaseTooltip,
        BaseButton
    },
    props: {
        releaseAlvId: String
    },
    data() {
        return {
            alvqa: 'label-releases-list-row-' + this.releaseAlvId + '-read-only-panel-tracks'
        }
    },
    computed: {
        tracks() {
            let release = this.$store.getters.getExpandedLabelReleases.find(release => {
                return release.alvId === this.releaseAlvId
            })

            let tracks = []
            for(let discNr in release.tracksOnRelease) {
                release.tracksOnRelease[discNr].forEach(track => {
                    tracks.push(track)
                })
            }

            return tracks
        },

        headers() {
            return [
				{ 
                    text: this.$t("lang_LABEL_RELEASES_TRACKS_CAPTION_DISC"), 
                    align: "left", 
                    width: "100px",
					value: "soundCarrierNumber",
					sortable: false
                },
                { 
                    text: this.$t("lang_LABEL_RELEASES_CAPTION_TRACKS_PANEL_POS"), 
                    align: "left",
                    width: "100px", 
                    value: "trackPosition",
					sortable: false
                },
                {
                    text: this.$t("lang_LABEL_TRACKS_CAPTION_TITLE"), 
                    align: "left", 
                    value: "title",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-title'
                },
                {
                    text: this.$t("lang_GENERAL_CAPTION_ISRC"), 
                    align: "left", 
                    value: "isrc",
                    width: '150px',
                    sortable: false,
                    alvqa: this.alvqa + '-header-isrc'
                },
                {
                    text: this.$t("lang_LABEL_TRACKS_CAPTION_ARTIST"), 
                    align: "left", 
                    value: "performer",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-performer'
                },
                {
                    text: this.$t("lang_LABEL_TRACKS_CAPTION_DURATION"), 
                    align: "left", 
                    value: "duration",
                    width: '130px',
                    sortable: false,
                    alvqa: this.alvqa + '-header-duration'
                },
                {
                    text: '', 
                    align: "right", 
                    value: "jumpToBtn",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-jump-to-button',
                    width: "100px"
                },
            ]
        },
    },
    methods:{
        jumpToTrack(alvId){
            this.$store.commit('setTracksSearch', alvId)
            this.$store.commit('setExpandedTracks', [])
            this.$store.commit('setExpandedTracks', alvId)
            this.$router.push( { name: 'Tracks' })
            this.$store.dispatch('fetchTracksDetails', alvId)
        },
    }
}
</script>